import { ICON } from './icons';

export const BILLING_V3_TIMESTAMP = new Date('2025-11-01T00:00:00.000Z');

export const MULTI_SHOP_DISCOUNT = 20;

export const ACTION = {
  UPGRADED: 'successfully upgraded',
  DELETED: 'deleted',
  UNSUBSCRIBED: 'unsubscribed',
  TRIAL_ACTIVATED: 'activated',
};

export const CARD_BRANDS = {
  amex: 'AmEx',
  diners: 'Diners Club',
  discover: 'Discover',
  jcb: 'JCB',
  mastercard: 'Mastercard',
  unionpay: 'UnionPay',
  visa: 'Visa',
};

export const PLAN = {
  TRIAL: 'trial',
  FREE: 'free',
  ERROR: 'error',
  PLUS: 'plus',
  LITE: 'lite',
  VIP: 'vip',
};

export const PLAN_NAME = {
  [PLAN.TRIAL]: 'Trial',
  [PLAN.FREE]: 'Free',
  [PLAN.PLUS]: 'Plus',
  [PLAN.LITE]: 'Lite',
};

export const TIER = {
  T_0: 'tier_0_500',
  T_501: 'tier_501_1000',
  T_1001: 'tier_1001_2500',
  T_2501: 'tier_2501_5000',
  T_5001: 'tier_5001_7500',
  T_7501: 'tier_7501_10000',
  T_10001: 'tier_10001_20000',
  T_20001: 'tier_20001_30000',
  T_30001: 'tier_30001_40000',
  T_40001: 'tier_40001_50000',
  T_50001: 'tier_50001_60000',
  T_60001: 'tier_60001_70000',
  T_70001: 'tier_70001_80000',
  T_80001: 'tier_80001_90000',
  T_90001: 'tier_90001_100000',
};

export const LEGACY_TIER_MAP = {
  tier_0_250: TIER.T_0,
  tier_251_500: TIER.T_0,
  tier_501_1000: TIER.T_501,
  tier_1001_2500: TIER.T_1001,
  tier_2501_5000: TIER.T_2501,
  tier_5001_7500: TIER.T_5001,
  tier_7501_10000: TIER.T_7501,
  tier_10001_20000: TIER.T_10001,
  tier_20001_30000: TIER.T_20001,
  tier_30001_40000: TIER.T_30001,
  tier_40001_50000: TIER.T_40001,
  tier_50001_60000: TIER.T_50001,
  tier_60001_70000: TIER.T_60001,
  tier_70001_plus: TIER.T_70001,
};

export const TIER_PRICE = {
  [PLAN.LITE]: {
    [TIER.T_0]: 19.95,
    [TIER.T_501]: 24.95,
    [TIER.T_1001]: 29.95,
    [TIER.T_2501]: 34.95,
    [TIER.T_5001]: 39.95,
    [TIER.T_7501]: 44.95,
    [TIER.T_10001]: 54.95,
    [TIER.T_20001]: 64.95,
    [TIER.T_30001]: 74.95,
    [TIER.T_40001]: 84.95,
    [TIER.T_50001]: 94.95,
    [TIER.T_60001]: 104.95,
    [TIER.T_70001]: 114.95,
    [TIER.T_80001]: 124.95,
    [TIER.T_90001]: 134.95,
  },
  [PLAN.PLUS]: {
    [TIER.T_0]: 29.95,
    [TIER.T_501]: 34.95,
    [TIER.T_1001]: 39.95,
    [TIER.T_2501]: 44.95,
    [TIER.T_5001]: 49.95,
    [TIER.T_7501]: 54.95,
    [TIER.T_10001]: 64.95,
    [TIER.T_20001]: 74.95,
    [TIER.T_30001]: 84.95,
    [TIER.T_40001]: 94.95,
    [TIER.T_50001]: 104.95,
    [TIER.T_60001]: 114.95,
    [TIER.T_70001]: 124.95,
    [TIER.T_80001]: 134.95,
    [TIER.T_90001]: 144.95,
  },
};

export const TIER_PRICE_DISCOUNTED = {
  [PLAN.LITE]: {
    [TIER.T_0]: 15.95,
    [TIER.T_501]: 19.95,
    [TIER.T_1001]: 23.95,
    [TIER.T_2501]: 27.95,
    [TIER.T_5001]: 31.95,
    [TIER.T_7501]: 35.95,
    [TIER.T_10001]: 43.95,
    [TIER.T_20001]: 51.95,
    [TIER.T_30001]: 59.95,
    [TIER.T_40001]: 67.95,
    [TIER.T_50001]: 75.95,
    [TIER.T_60001]: 83.95,
    [TIER.T_70001]: 91.95,
    [TIER.T_80001]: 99.95,
    [TIER.T_90001]: 107.95,
  },
  [PLAN.PLUS]: {
    [TIER.T_0]: 23.95,
    [TIER.T_501]: 27.95,
    [TIER.T_1001]: 31.95,
    [TIER.T_2501]: 35.95,
    [TIER.T_5001]: 39.95,
    [TIER.T_7501]: 43.95,
    [TIER.T_10001]: 51.95,
    [TIER.T_20001]: 59.95,
    [TIER.T_30001]: 67.95,
    [TIER.T_40001]: 75.95,
    [TIER.T_50001]: 83.95,
    [TIER.T_60001]: 91.95,
    [TIER.T_70001]: 99.95,
    [TIER.T_80001]: 107.95,
    [TIER.T_90001]: 115.95,
  },
};

export const TIER_LIMITS = {
  [TIER.T_0]: [0, 500],
  [TIER.T_501]: [501, 1000],
  [TIER.T_1001]: [1001, 2500],
  [TIER.T_2501]: [2501, 5000],
  [TIER.T_5001]: [5001, 7500],
  [TIER.T_7501]: [7501, 10000],
  [TIER.T_10001]: [10001, 20000],
  [TIER.T_20001]: [20001, 30000],
  [TIER.T_30001]: [30001, 40000],
  [TIER.T_40001]: [40001, 50000],
  [TIER.T_50001]: [50001, 60000],
  [TIER.T_60001]: [60001, 70000],
  [TIER.T_70001]: [70001, 80000],
  [TIER.T_80001]: [80001, 90000],
  [TIER.T_90001]: [90001, 100000],
};

export const LAST_TIER_LIMIT = TIER_LIMITS[TIER.T_90001][0];

export const BILLING_FEATURES = {
  AI_BULK_LISTING_OPTIMIZATION: 'ai_bulk_listing_optimization',
  AI_COPY_LISTINGS: 'ai_copy_listings',
  PHOTO_EDITOR_AI_BACKGROUNDS: 'photo_editor_ai_backgrounds',
  PHOTO_EDITOR_AI_EDIT: 'photo_editor_ai_edit',
  PHOTO_EDITOR_AI_ENHANCE: 'photo_editor_ai_enhance',
  PHOTO_EDITOR_AI_EXPAND: 'photo_editor_ai_expand',
  PHOTO_EDITOR_IMAGE_TO_VIDEO: 'photo_editor_image_to_video',
  PROFILES_STANDARD_PROFILES: 'standard_profiles',
  PROFILES_AI_PROFILES: 'ai_profiles',
  STUDIO_VIDEOS: 'studio_videos',
};

export const BILLING_FEATURE_TO_PLAN = {
  [BILLING_FEATURES.AI_BULK_LISTING_OPTIMIZATION]: { [PLAN.LITE]: false, [PLAN.PLUS]: true },
  [BILLING_FEATURES.AI_COPY_LISTINGS]: { [PLAN.LITE]: false, [PLAN.PLUS]: true },
  [BILLING_FEATURES.PHOTO_EDITOR_AI_BACKGROUNDS]: { [PLAN.LITE]: false, [PLAN.PLUS]: true },
  [BILLING_FEATURES.PHOTO_EDITOR_AI_EDIT]: { [PLAN.LITE]: false, [PLAN.PLUS]: true },
  [BILLING_FEATURES.PHOTO_EDITOR_AI_ENHANCE]: { [PLAN.LITE]: false, [PLAN.PLUS]: true },
  [BILLING_FEATURES.PHOTO_EDITOR_AI_EXPAND]: { [PLAN.LITE]: false, [PLAN.PLUS]: true },
  [BILLING_FEATURES.PHOTO_EDITOR_IMAGE_TO_VIDEO]: { [PLAN.LITE]: false, [PLAN.PLUS]: true },
  [BILLING_FEATURES.PROFILES_AI_PROFILES]: { [PLAN.LITE]: false, [PLAN.PLUS]: false },
  [BILLING_FEATURES.PROFILES_STANDARD_PROFILES]: { [PLAN.LITE]: 5, [PLAN.PLUS]: Infinity },
  [BILLING_FEATURES.STUDIO_VIDEOS]: { [PLAN.LITE]: false, [PLAN.PLUS]: true },
};

export const PAYWALL_FEATURE_NAMES = {
  [BILLING_FEATURES.AI_BULK_LISTING_OPTIMIZATION]: 'AI bulk listing optimization',
  [BILLING_FEATURES.AI_COPY_LISTINGS]: 'AI copy listings',
  [BILLING_FEATURES.PHOTO_EDITOR_AI_BACKGROUNDS]: 'AI Backgrounds',
  [BILLING_FEATURES.PHOTO_EDITOR_AI_EDIT]: 'AI Edit',
  [BILLING_FEATURES.PHOTO_EDITOR_AI_ENHANCE]: 'AI Enhance',
  [BILLING_FEATURES.PHOTO_EDITOR_AI_EXPAND]: 'AI Expand',
  [BILLING_FEATURES.PHOTO_EDITOR_IMAGE_TO_VIDEO]: 'Image to video',
  [BILLING_FEATURES.PROFILES_STANDARD_PROFILES]: 'Standard profiles',
  [BILLING_FEATURES.PROFILES_AI_PROFILES]: 'AI profiles',
  [BILLING_FEATURES.STUDIO_VIDEOS]: 'Studio videos',
};

export const FEATURES_DATA = [
  {
    chapter: 'Listings',
    icon: ICON.LIST,
    options: [
      {
        name: 'Listing & attribute scoring',
        tooltip: 'Precise quality scores for every listing and specific attributes',
        [PLAN.LITE]: true,
        [PLAN.PLUS]: true,
      },
      {
        name: 'Create new listings',
        tooltip: '',
        [PLAN.LITE]: true,
        [PLAN.PLUS]: true,
      },
      {
        name: 'Edit listings individually',
        tooltip: '',
        [PLAN.LITE]: true,
        [PLAN.PLUS]: true,
      },
      {
        name: 'AI individual listing optimization',
        tooltip: 'One-click listing optimization for multiple attributes',
        [PLAN.LITE]: true,
        [PLAN.PLUS]: true,
      },
      {
        name: 'Bulk edit listings',
        tooltip: '',
        [PLAN.LITE]: true,
        [PLAN.PLUS]: true,
      },
      {
        name: 'AI bulk listing optimization',
        tooltip: 'One-click optimization for multiple attributes in bulk',
        [PLAN.LITE]: false,
        [PLAN.PLUS]: true,
      },
      {
        name: 'Copy listings',
        tooltip: 'Copy listings within the same shop or between different shops',
        [PLAN.LITE]: true,
        [PLAN.PLUS]: true,
      },
      {
        name: 'AI copy listings',
        tooltip: 'Automatically optimize listings when copying between shops',
        [PLAN.LITE]: false,
        [PLAN.PLUS]: true,
      },
      {
        name: 'Merge listings',
        tooltip: 'Merge existing listings between multiple shops',
        [PLAN.LITE]: true,
        [PLAN.PLUS]: true,
      },
      {
        name: 'Activate new channels',
        tooltip: 'Copy existing listings to activate new channels',
        [PLAN.LITE]: true,
        [PLAN.PLUS]: true,
      },
      {
        name: 'CSV export & import',
        tooltip: '',
        [PLAN.LITE]: true,
        [PLAN.PLUS]: true,
      },
      {
        name: 'Publish listings',
        tooltip: '',
        [PLAN.LITE]: true,
        [PLAN.PLUS]: true,
      },
    ],
  },
  {
    chapter: 'Schedule',
    icon: ICON.CLOCK,
    options: [
      {
        name: 'Schedule updates',
        tooltip: '',
        [PLAN.LITE]: true,
        [PLAN.PLUS]: true,
      },
      {
        name: 'Schedule publication',
        tooltip: '',
        [PLAN.LITE]: true,
        [PLAN.PLUS]: true,
      },
    ],
  },
  {
    chapter: 'Profiles',
    icon: ICON.PROFILES,
    options: [
      {
        name: 'Standard profiles',
        tooltip: 'Streamline listing creation and centralize editing for similar products',
        [PLAN.LITE]: 5,
        [PLAN.PLUS]: 'Unlimited',
      },
      {
        name: 'AI profiles',
        tooltip: '',
        [PLAN.LITE]: false,
        [PLAN.PLUS]: 'Coming soon',
      },
    ],
  },
  {
    chapter: 'Studio',
    icon: ICON.IMAGE,
    options: [
      {
        name: 'Photo library',
        tooltip: 'Centrally view, edit, and manage all product photos',
        [PLAN.LITE]: true,
        [PLAN.PLUS]: true,
      },
      {
        name: 'AI photo unification',
        tooltip: 'Automatically unify photos that exist across multiple listings',
        [PLAN.LITE]: true,
        [PLAN.PLUS]: true,
      },
      {
        name: 'AI alt text generation',
        tooltip: '',
        [PLAN.LITE]: true,
        [PLAN.PLUS]: true,
      },
      {
        name: 'AI photo background removal',
        tooltip: '',
        [PLAN.LITE]: true,
        [PLAN.PLUS]: true,
      },
      {
        name: 'Photo background blur',
        tooltip: '',
        [PLAN.LITE]: true,
        [PLAN.PLUS]: true,
      },
      {
        name: 'Color and photo backgrounds',
        tooltip: '',
        [PLAN.LITE]: true,
        [PLAN.PLUS]: true,
      },
      {
        name: 'AI background generation',
        tooltip: 'Create beautiful product backgrounds and full scenes with AI',
        [PLAN.LITE]: false,
        [PLAN.PLUS]: true,
      },
      {
        name: 'AI photo editing',
        tooltip: '',
        [PLAN.LITE]: false,
        [PLAN.PLUS]: true,
      },
      {
        name: 'AI photo expand',
        tooltip: 'Optimize photos to work perfectly across all major channels',
        [PLAN.LITE]: false,
        [PLAN.PLUS]: true,
      },
      {
        name: 'AI photo crop',
        tooltip: '',
        [PLAN.LITE]: true,
        [PLAN.PLUS]: true,
      },
      {
        name: 'AI photo enhance',
        tooltip: 'One-click AI powered photo enhancement',
        [PLAN.LITE]: false,
        [PLAN.PLUS]: true,
      },
      {
        name: 'Photo filters',
        tooltip: '',
        [PLAN.LITE]: true,
        [PLAN.PLUS]: true,
      },
      {
        name: 'Photo light & color adjust',
        tooltip: '',
        [PLAN.LITE]: true,
        [PLAN.PLUS]: true,
      },
      {
        name: 'AI mockup generation',
        tooltip: '',
        [PLAN.LITE]: false,
        [PLAN.PLUS]: 'Coming soon',
      },
      {
        name: 'AI photo to video creation',
        tooltip: '',
        [PLAN.LITE]: false,
        [PLAN.PLUS]: 'Coming soon',
      },
      {
        name: 'Bulk photo editing',
        tooltip: '',
        [PLAN.LITE]: false,
        [PLAN.PLUS]: 'Coming soon',
      },
    ],
  },
];
